import React, { useEffect, useState } from 'react'
import { getCurrentSession } from './KeycloakHelpmethods'

const ActiveOrNot = (props) => {

    const [activeornot, setActiveOrNot] = useState(null);

useEffect(()=>
{


    const fetchSession=async ()=>
    {

        let data= await getCurrentSession(props.userid);
        setActiveOrNot(data);

    }

    fetchSession();
 
   
  
},[])

    
  return (
    <div>{activeornot && activeornot.length>0?<>Active</>:<div style={{color:"red"}}>Not Active</div>}</div>
  )
}

export default ActiveOrNot